exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".code[data-v-2385e7ae] {\n  font-size: 12px;\n  display: block;\n  font-family: monospace;\n  white-space: pre;\n  margin: 0 1em;\n}", ""]);

// exports
